import { useEffect, useState } from 'react';
import { INGREDIENT_BY_ID } from '../data/ingredients.js';
import { fetchLeaderboard, submitShowdown } from '../lib/api.js';
import Leaderboard from './Leaderboard.jsx';
import ScientificResults from './ScientificResults.jsx';

export default function Results({ sessionId, tournament, onPlayAgain }) {
  const [status, setStatus] = useState('submitting'); // submitting | ready | error
  const [leaderboard, setLeaderboard] = useState({ rows: [], completedSessions: 0 });

  const winner = INGREDIENT_BY_ID.get(tournament.winner);

  useEffect(() => {
    let cancelled = false;

    async function run() {
      try {
        const rounds = tournament.log.map((entry) => ({
          round: entry.round,
          winnerSlug: INGREDIENT_BY_ID.get(entry.winnerId).slug,
          loserSlug: INGREDIENT_BY_ID.get(entry.loserId).slug,
        }));
        await submitShowdown(sessionId, winner.slug, rounds);
        const data = await fetchLeaderboard();
        if (!cancelled) {
          setLeaderboard(data);
          setStatus('ready');
        }
      } catch (err) {
        console.error('Failed to submit/load results', err);
        if (!cancelled) setStatus('error');
      }
    }

    run();
    return () => {
      cancelled = true;
    };
    // sessionId + winner are stable for the lifetime of a completed tournament.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col items-center px-5 py-10 text-center sm:py-16">
      <p className="text-sm font-bold uppercase tracking-[0.2em] text-showdown-pink sm:text-base">
        🏆 People&rsquo;s Choice
      </p>

      <h1 className="mt-3 font-display text-4xl font-extrabold text-showdown-blue sm:text-5xl">Your Winner</h1>
      <p className="mt-4 break-words text-3xl font-extrabold text-showdown-pink sm:text-4xl">{winner.name}</p>
      <p className="text-sm font-semibold uppercase tracking-wide text-showdown-cream/60 sm:text-base">
        1 teaspoon
      </p>

      <div className="mt-10 w-full">
        {status === 'submitting' && (
          <p role="status" className="text-showdown-cream/70">
            Saving your vote&hellip;
          </p>
        )}
        {status === 'error' && (
          <p role="alert" className="rounded-2xl bg-showdown-pink/20 p-4 text-showdown-cream/90">
            We couldn&rsquo;t reach the scoreboard. Your pick still counts locally — check your
            connection and reopen this page to try again.
          </p>
        )}
        {status === 'ready' && <Leaderboard rows={leaderboard.rows} yourWinnerId={winner.id} />}
      </div>

      {status === 'ready' && <ScientificResults />}

      <button
        type="button"
        onClick={onPlayAgain}
        className="mt-10 w-full max-w-xs rounded-full bg-showdown-pink px-8 py-5 text-xl font-extrabold uppercase tracking-wide text-showdown-ink shadow-lg transition
                   hover:bg-showdown-pink-dark focus-visible:outline focus-visible:outline-4 focus-visible:outline-showdown-yellow active:scale-95"
      >
        Play Again
      </button>
    </main>
  );
}
